import React from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FAIXAS = [["ate30", "≤ 30 dias"], ["acima30", "> 30 dias"], ["acima90", "> 90 dias"]];
const FINS = [["correcao_reparo", "Correção / reparo"], ["vistoria_tecnica", "Vistoria técnica"]];

export function RevisaoShowroom({ sid, itens = [], servs = [] }) {
  const [faixa, setFaixa] = React.useState("ate30");
  const [fin, setFin] = React.useState("correcao_reparo");
  const [busy, setBusy] = React.useState(false);
  const statusDe = (id) => servs.find(s => s.id === id) || {};

  const acao = async (a, body = {}) => {
    setBusy(true);
    try {
      await axios.post(`${API}/demo/sessao/${sid}/cenario/revisao/${a}`, body);
      toast.success(a === "abrir" ? "OS filha criada pelo fluxo real" : "Etapa avançada");
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-5 rounded-2xl border border-[#34D399]/30 bg-[#34D399]/5 p-4" data-testid="demo-revisao-controles">
      <div className="font-bold text-[#34D399] text-sm mb-2">Revisão / Vistoria — abrir pelo fluxo real</div>
      <div className="flex flex-wrap gap-1.5 items-center">
        <select value={faixa} onChange={e => setFaixa(e.target.value)} data-testid="demo-revisao-faixa"
          className="bg-[#142766] border border-[#126BFF]/30 rounded-lg text-xs font-bold px-2 py-1.5">
          {FAIXAS.map(([v, l]) => <option key={v} value={v}>Montagem concluída há {l}</option>)}
        </select>
        <select value={fin} onChange={e => setFin(e.target.value)} data-testid="demo-revisao-finalidade"
          className="bg-[#142766] border border-[#126BFF]/30 rounded-lg text-xs font-bold px-2 py-1.5">
          {FINS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <button disabled={busy} onClick={() => acao("abrir", { faixa, finalidade: fin })} data-testid="demo-revisao-abrir"
          className="px-3 py-1.5 rounded-lg bg-[#00A859] text-xs font-bold hover:bg-[#00A859]/80 disabled:opacity-50">Abrir Revisão / Vistoria</button>
      </div>
      <div className="mt-3 space-y-1.5">
        {itens.map(it => {
          const st = statusDe(it.filha_id);
          return (
            <div key={it.filha_id} className="rounded-xl border border-white/10 bg-[#142766]/40 px-3 py-2 text-xs" data-testid={`demo-revisao-item-${it.n}`}>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                  <b>{it.finalidade === "vistoria_tecnica" ? "Vistoria" : "Revisão"} {it.pim_filha}</b>
                  <span className="ml-2 text-white/40">mãe {it.pim_mae} · há {it.dias_contexto}d</span>
                  <span className="ml-2 text-[#6FA6FF] font-bold">{st.status || "—"}</span>
                </div>
                <div className="flex gap-1.5">
                  <button disabled={busy} onClick={() => acao("aceitar_agendar", { filha_id: it.filha_id })} data-testid={`demo-revisao-aceitar-${it.n}`}
                    className="px-2 py-1 rounded bg-[#126BFF]/15 text-[#6FA6FF] font-bold">Aceitar e agendar</button>
                  <button disabled={busy} onClick={() => acao("executar_concluir", { filha_id: it.filha_id })} data-testid={`demo-revisao-concluir-${it.n}`}
                    className="px-2 py-1 rounded bg-[#126BFF]/15 text-[#6FA6FF] font-bold">Executar e concluir</button>
                </div>
              </div>
              <div className="text-white/40 mt-1">
                {st.sem_pagamento ? "Regra real: ≤30 dias → mesmo montador, sem novo repasse" : "Regra real: Tabela de Valores vigente no encerramento"}
                {it.avaliacao_id && ` · decisão humana da Empresa via Avaliação Pós-Montagem${it.montadora_http ? ` (Montadora → HTTP ${it.montadora_http})` : ""}`}
              </div>
            </div>
          );
        })}
      </div>
      <div className="text-[10px] text-white/40 mt-2">A OS filha nasce por criar_revisao / Avaliação Pós-Montagem → _criar_os_filha. O Showroom só posiciona a data da montagem original; faixa, pagamento e montador vêm da regra real. Na sessão Demo ativa, datas não bloqueiam a execução.</div>
    </div>
  );
}
